export class PlantInvoiceDetailsRequest {
    saleOrderId?: number;
    financialYear?:string
    tab?:string
    unit?:number

    /**
     * @param saleOrderId
     * @param financialYear
    */
    constructor(saleOrderId?: number,financialYear?:string,tab?:string, unit?:number){
       this.saleOrderId=saleOrderId;
       this.financialYear = financialYear
       this.tab = tab
       this.unit = unit
    }
}